import React from "react";
import "./Footer.css";
import { BsFacebook, BsLinkedin, BsGithub, BsTwitter } from "react-icons/bs";

const Footer = () => {
  return (
    <div className="Footer">
      <h2>My Social links</h2>
      <div className="footer-container">
        <div className="footer-link">
          <a
            href="https://web.facebook.com/boniface.emmanuel.5249/"
            target="_blank"
          >
            <BsFacebook color={"#4c00ff"} className="f-icon" size={60} />
          </a>
        </div>
        <div className="footer-link">
          <a href="linkedin" target="_blank">
            <BsLinkedin className="f-icon" color={"#0e76a8"} size={60} />
          </a>
        </div>
        <div className="footer-link">
          <a href="https://github.com/Gemack" target="_blank">
            <BsGithub color={"#000"} className="f-icon" size={60} />
          </a>
        </div>
        <div className="footer-link">
          <a href="https://twitter.com/Emack300" target="_blank">
            <BsTwitter color={"skyblue"} className="f-icon" size={60} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
